import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-matched-transactions.presenters.MatchedTransactionListPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load the matched transactions.',
  },
})
